import React, { useEffect, useState } from 'react';
import DrawerQuickOpenCard from '@/pages/Member/QuickOpenCard/DrawerQuickOpenCard';
import { quickOpenCardController } from '@/pages/Member/QuickOpenCard/controller';

export default function QuickOpenCardPortal() {
  const [isOpen, setIsOpen] = useState(() => quickOpenCardController.getSnapshot());

  useEffect(() => {
    return quickOpenCardController.subscribe(() => {
      setIsOpen(quickOpenCardController.getSnapshot());
    });
  }, []);

  return <DrawerQuickOpenCard open={isOpen} onClose={() => quickOpenCardController.close()} />;
}
